/**
 * Newsletter Modal - Simple & Professional
 */
class NewsletterForm {
	constructor() {
		this.newsletterSection = document.getElementById('newsletter-section');
		this.form = this.newsletterSection.querySelector('.newsletter-form');
		this.reCaptchaContainer = this.form.querySelector('.recaptcha-container');
		this.submitBtn = this.form.querySelector('button[type="submit"]');
		this.messageEl = this.form.querySelector('.newsletter-form-message');
		this.readMoreBtn = this.form.querySelector('.read-more-btn');

		this.isSubmitting = false;
		this.widgetId = null;

		this.init();
	}

	init() {
		this.bindEvents();
		this.initRecaptcha();
	}

	initRecaptcha() {
		// Wait for grecaptcha to load, then initialize
		if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
			grecaptcha.enterprise.ready(() => {
				this.widgetId = grecaptcha.enterprise.render(this.reCaptchaContainer, {
					'sitekey': fh_config.recaptcha_key,
					'size': 'invisible',
					'action': 'submit',
					'callback': (token) => this.submitFormWithToken(token),
					'error-callback': () => {
						this.showMessage('Weryfikacja reCAPTCHA nie powiodła się. Proszę spróbować ponownie.', 'error');
						this.isSubmitting = false;
						this.updateSubmitButton();
					}
				});
			});
		}
	}

	bindEvents() {
		this.form.addEventListener('change', () => this.updateSubmitButton());
		this.form.addEventListener('submit', (e) => this.handleSubmit(e));

		// Obsługa rozwijania tekstu
		this.readMoreBtn.addEventListener('click', (e) => {
			if (e.target.classList.contains('read-more-btn')) {
				this.toggleReadMore(e.target);
			}
		});
	}

	updateSubmitButton() {
		const isFormValid = this.form.checkValidity();
		this.submitBtn.disabled = !isFormValid || this.isSubmitting;
	}

	handleSubmit(e) {
		e.preventDefault();

		// if (this.isSubmitting || !this.form.checkValidity()) return;

		// For invisible reCAPTCHA, execute the challenge
		if (this.widgetId !== null && grecaptcha?.enterprise) {
			this.isSubmitting = true;
			this.updateSubmitButton();

			try {
				grecaptcha.enterprise.ready(async () => {
					await grecaptcha.enterprise.execute(this.widgetId);
				});
			} catch (error) {
				this.showMessage('Weryfikacja reCAPTCHA nie powiodła się. Proszę spróbować ponownie.', 'error');
				this.isSubmitting = false;
				this.updateSubmitButton();
			}
		}
	}

	async submitFormWithToken(token) {
		if (!token) {
			this.showMessage('Weryfikacja reCAPTCHA nie powiodła się. Proszę spróbować ponownie.', 'error');
			this.isSubmitting = false;
			this.updateSubmitButton();
			return;
		}

		this.clearMessage();

		try {
			const formData = new FormData(this.form);
			const data = Object.fromEntries(formData.entries());
			data['g-recaptcha-response'] = token;

			const response = await fetch('/wp-json/fh/v1/subscribe', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(data),
			});

			const result = await response.json();

			if (result.success) {
				this.form.reset();
				if (result.thank_you) {
					window.location.href = result.thank_you;
				}
			} else {
				this.showMessage(result.message || 'Subskrypcja nie powiodła się. Proszę spróbować ponownie.', 'error');
			}

		} catch (error) {
			this.showMessage('Błąd sieci. Proszę spróbować ponownie.', 'error');
		} finally {
			this.isSubmitting = false;
			this.updateSubmitButton();
		}
	}

	showMessage(message, type) {
		this.messageEl.innerHTML = message;
		this.messageEl.className = `newsletter-form-message ${type}`;
	}

	clearMessage() {
		this.messageEl.innerHTML = '';
		this.messageEl.className = 'newsletter-form-message';
	}

	toggleReadMore(button) {
		const targetId = button.getAttribute('data-target');
		const content = document.getElementById(targetId);

		if (!content) return;

		const isVisible = content.style.display !== 'none';

		if (isVisible) {
			content.style.display = 'none';
		} else {
			content.style.display = 'block';
		}
	}
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.newsletter-form')) {
		new NewsletterForm();
	}
});
